import(/* webpackMode: "eager" */ "/app/app/[locale]/page.tsx");
